// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--1gMeo","vas_item":"a10a3f92e9--vas_item--2wQfE"};